<template>
  <div :class="jel_getClassObject(content)">
    <EditableArea
      v-if="hasInfo"
      :content="content.confirmationCanafe"
      :parentTemplateId="metadata['mgnl:template']"
    />
    <div
      v-else
      id="spinner"
      class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
    >
      <b-spinner :label="$t('chargement')"></b-spinner>
    </div>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';
import { inMgnl } from '@/helpers/AppHelpers';
import { traiterRetourConnexion } from '@/services/api/compte/profile';

export default {
  name: 'FormulaireConfirmationCanafe',
  components: { EditableArea },
  props: {
    metadata: { type: Object, required: true },
    content: { type: Object, required: true },
  },
  data() {
    return {
      isInfoChargee: false,
    };
  },
  computed: {
    hasInfo() {
      return this.isInfoChargee || inMgnl;
    },
  },

  mounted() {
    this.getProfileComplet();
  },

  methods: {
    getProfileComplet() {
      if (!inMgnl) {
        this.$store.commit('profileComplet/RESET');
        this.$store
          .dispatch('profileComplet/getProfileComplet')
          .then(() => {
            this.isInfoChargee = true;
            this.$store.dispatch('profileComplet/updateProfileUpdateStatusSeen');
          })
          .catch((error) => {
            if (error.url) {
              window.location.href = error.url;
            }
            traiterRetourConnexion().then((response) => {
              window.location.href = response.url;
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
